import { ArrowContainer } from '@hellodarwin/core/lib/components/common/button/arrow/styles';
import styled from 'styled-components';

export const ChecklistRow = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
  margin-top: ${({ theme }) => theme.spacing.sm}px;

  &:hover,
  &:active {
    &:not(:disabled) {
      ${ArrowContainer}::after {
        transform: scaleX(1);
      }
    }
  }
`;
